"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: military/base.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = exports.MilitaryBase = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const geo_bounding_box_1 = require("../common/geo_bounding_box");
const geo_point_1 = require("../common/geo_point");
const geo_shape_1 = require("../common/geo_shape");
const address_1 = require("./address");
exports.protobufPackage = "military";
function createBaseMilitaryBase() {
    return {
        id: "",
        updatedOn: "",
        docId: "",
        slug: "",
        displayName: "",
        displayAddress: "",
        otherNames: [],
        address: undefined,
        geoPosition: undefined,
        geoShape: undefined,
        geoBoundingBox: undefined,
        contact: undefined,
        militaryBranch: "",
    };
}
exports.MilitaryBase = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.updatedOn !== "") {
            writer.uint32(18).string(message.updatedOn);
        }
        if (message.docId !== "") {
            writer.uint32(26).string(message.docId);
        }
        if (message.slug !== "") {
            writer.uint32(34).string(message.slug);
        }
        if (message.displayName !== "") {
            writer.uint32(42).string(message.displayName);
        }
        if (message.displayAddress !== "") {
            writer.uint32(50).string(message.displayAddress);
        }
        for (const v of message.otherNames) {
            writer.uint32(58).string(v);
        }
        if (message.address !== undefined) {
            address_1.Address.encode(message.address, writer.uint32(66).fork()).join();
        }
        if (message.geoPosition !== undefined) {
            geo_point_1.GeoPoint.encode(message.geoPosition, writer.uint32(74).fork()).join();
        }
        if (message.geoShape !== undefined) {
            geo_shape_1.GeoShape.encode(message.geoShape, writer.uint32(82).fork()).join();
        }
        if (message.geoBoundingBox !== undefined) {
            geo_bounding_box_1.GeoBoundingBox.encode(message.geoBoundingBox, writer.uint32(90).fork()).join();
        }
        if (message.contact !== undefined) {
            exports.Contact.encode(message.contact, writer.uint32(98).fork()).join();
        }
        if (message.militaryBranch !== "") {
            writer.uint32(106).string(message.militaryBranch);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMilitaryBase();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.updatedOn = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.docId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.displayName = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.displayAddress = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.otherNames.push(reader.string());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.address = address_1.Address.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.geoPosition = geo_point_1.GeoPoint.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.geoShape = geo_shape_1.GeoShape.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.geoBoundingBox = geo_bounding_box_1.GeoBoundingBox.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.contact = exports.Contact.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.militaryBranch = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            updatedOn: isSet(object.updatedOn) ? globalThis.String(object.updatedOn) : "",
            docId: isSet(object.docId) ? globalThis.String(object.docId) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : "",
            displayAddress: isSet(object.displayAddress) ? globalThis.String(object.displayAddress) : "",
            otherNames: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.otherNames)
                ? object.otherNames.map((e) => globalThis.String(e))
                : [],
            address: isSet(object.address) ? address_1.Address.fromJSON(object.address) : undefined,
            geoPosition: isSet(object.geoPosition) ? geo_point_1.GeoPoint.fromJSON(object.geoPosition) : undefined,
            geoShape: isSet(object.geoShape) ? geo_shape_1.GeoShape.fromJSON(object.geoShape) : undefined,
            geoBoundingBox: isSet(object.geoBoundingBox) ? geo_bounding_box_1.GeoBoundingBox.fromJSON(object.geoBoundingBox) : undefined,
            contact: isSet(object.contact) ? exports.Contact.fromJSON(object.contact) : undefined,
            militaryBranch: isSet(object.militaryBranch) ? globalThis.String(object.militaryBranch) : "",
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.updatedOn !== "") {
            obj.updatedOn = message.updatedOn;
        }
        if (message.docId !== "") {
            obj.docId = message.docId;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.displayName !== "") {
            obj.displayName = message.displayName;
        }
        if (message.displayAddress !== "") {
            obj.displayAddress = message.displayAddress;
        }
        if ((_a = message.otherNames) === null || _a === void 0 ? void 0 : _a.length) {
            obj.otherNames = message.otherNames;
        }
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.geoPosition !== undefined) {
            obj.geoPosition = geo_point_1.GeoPoint.toJSON(message.geoPosition);
        }
        if (message.geoShape !== undefined) {
            obj.geoShape = geo_shape_1.GeoShape.toJSON(message.geoShape);
        }
        if (message.geoBoundingBox !== undefined) {
            obj.geoBoundingBox = geo_bounding_box_1.GeoBoundingBox.toJSON(message.geoBoundingBox);
        }
        if (message.contact !== undefined) {
            obj.contact = exports.Contact.toJSON(message.contact);
        }
        if (message.militaryBranch !== "") {
            obj.militaryBranch = message.militaryBranch;
        }
        return obj;
    },
    create(base) {
        return exports.MilitaryBase.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseMilitaryBase();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.updatedOn = (_b = object.updatedOn) !== null && _b !== void 0 ? _b : "";
        message.docId = (_c = object.docId) !== null && _c !== void 0 ? _c : "";
        message.slug = (_d = object.slug) !== null && _d !== void 0 ? _d : "";
        message.displayName = (_e = object.displayName) !== null && _e !== void 0 ? _e : "";
        message.displayAddress = (_f = object.displayAddress) !== null && _f !== void 0 ? _f : "";
        message.otherNames = ((_g = object.otherNames) === null || _g === void 0 ? void 0 : _g.map((e) => e)) || [];
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        message.geoPosition = (object.geoPosition !== undefined && object.geoPosition !== null)
            ? geo_point_1.GeoPoint.fromPartial(object.geoPosition)
            : undefined;
        message.geoShape = (object.geoShape !== undefined && object.geoShape !== null)
            ? geo_shape_1.GeoShape.fromPartial(object.geoShape)
            : undefined;
        message.geoBoundingBox = (object.geoBoundingBox !== undefined && object.geoBoundingBox !== null)
            ? geo_bounding_box_1.GeoBoundingBox.fromPartial(object.geoBoundingBox)
            : undefined;
        message.contact = (object.contact !== undefined && object.contact !== null)
            ? exports.Contact.fromPartial(object.contact)
            : undefined;
        message.militaryBranch = (_h = object.militaryBranch) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
function createBaseContact() {
    return { telNum: "", faxNum: "", website: "", moreInfo: "" };
}
exports.Contact = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.telNum !== "") {
            writer.uint32(10).string(message.telNum);
        }
        if (message.faxNum !== "") {
            writer.uint32(18).string(message.faxNum);
        }
        if (message.website !== "") {
            writer.uint32(26).string(message.website);
        }
        if (message.moreInfo !== "") {
            writer.uint32(34).string(message.moreInfo);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseContact();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.telNum = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.faxNum = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.website = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.moreInfo = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            telNum: isSet(object.telNum) ? globalThis.String(object.telNum) : "",
            faxNum: isSet(object.faxNum) ? globalThis.String(object.faxNum) : "",
            website: isSet(object.website) ? globalThis.String(object.website) : "",
            moreInfo: isSet(object.moreInfo) ? globalThis.String(object.moreInfo) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.telNum !== "") {
            obj.telNum = message.telNum;
        }
        if (message.faxNum !== "") {
            obj.faxNum = message.faxNum;
        }
        if (message.website !== "") {
            obj.website = message.website;
        }
        if (message.moreInfo !== "") {
            obj.moreInfo = message.moreInfo;
        }
        return obj;
    },
    create(base) {
        return exports.Contact.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseContact();
        message.telNum = (_a = object.telNum) !== null && _a !== void 0 ? _a : "";
        message.faxNum = (_b = object.faxNum) !== null && _b !== void 0 ? _b : "";
        message.website = (_c = object.website) !== null && _c !== void 0 ? _c : "";
        message.moreInfo = (_d = object.moreInfo) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=base.js.map